import {APP_ROUTES} from './const';
import RequireAccessToPaymentFeatures from './hocs/RequireAccessToPaymentFeatures';
import RequireAuth from './hocs/RequireAuth';
import RequireMaintenanceStatus from './hocs/RequireMaintenanceStatus';
import RequireNecessaryData from './hocs/RequireNecessaryData';
import RequireProducts from './hocs/RequireProducts';
import RequireSubscription from './hocs/RequireSubscription';
import RequireUserNotToBeGuest from './hocs/RequireUserNotToBeGuest';
import Layout from './Layout';
import Bills from './pages/Bills/Bills';
import Connections from './pages/Connections/Connections';
import ConnectorAuthenticationCallbackPage from './pages/ConnectorAuthenticationCallbackPage/ConnectorAuthenticationCallbackPage';
import ErrorComponent from './pages/ErrorComponent/ErrorComponent';
import Home from './pages/Home/Home';
import IframeDisplay from './pages/IframeDisplay/IframeDisplay';
import Login from './pages/Login/Login';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import Products from './pages/Products/Products';
import Profile from './pages/Profile/Profile';
import RestrictedAccess from './pages/RestrictedAccess/RestrictedAccess';
import Subscribe from './pages/Subscribe/Subscribe';
import UserSecrets from './pages/UserSecrets/UserSecrets';

const routes = [
  {
    path: APP_ROUTES.login,
    errorElement: <ErrorComponent />,
    element: (
      <RequireMaintenanceStatus>
        <RequireNecessaryData numberOfApiCallsToMake={1}>
          <Login />
        </RequireNecessaryData>
      </RequireMaintenanceStatus>
    )
  },
  {
    path: '/tiime-oauth-callback',
    errorElement: <ErrorComponent />,
    element: <ConnectorAuthenticationCallbackPage />
  },
  {
    path: '/pennylane-oauth-callback',
    errorElement: <ErrorComponent />,
    element: (
      <RequireNecessaryData>
        <ConnectorAuthenticationCallbackPage />
      </RequireNecessaryData>
    )
  },
  {
    path: '/fulll-oauth-callback',
    errorElement: <ErrorComponent />,
    element: (
      <RequireNecessaryData>
        <ConnectorAuthenticationCallbackPage />
      </RequireNecessaryData>
    )
  },
  {
    path: APP_ROUTES.subscribe,
    errorElement: <ErrorComponent />,
    element: (
      <RequireMaintenanceStatus>
        <RequireAuth numberOfApiCallsToMake={4}>
          <RequireNecessaryData>
            <Subscribe />
          </RequireNecessaryData>
        </RequireAuth>
      </RequireMaintenanceStatus>
    )
  },
  {
    path: APP_ROUTES.home,
    errorElement: <ErrorComponent />,
    children: [
      {
        path: APP_ROUTES.home,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={4}>
              <RequireSubscription>
                <RequireNecessaryData>
                  <Layout>
                    <Home />
                  </Layout>
                </RequireNecessaryData>
              </RequireSubscription>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },

      // The following route may seem a bit hacky : in fact, the <Report> page is included INSIDE the Layout component.
      // That's why the Layout component here does not have any page child here.
      // This modification has been done to implement Power BI reports bootstrapping (preloading).
      // Whatever the page we land on, the <Report> is present inside the layout. It is just hidden to the user and pre-loaded to improve perf and spinners times.
      // Once we land on the <Report> page (url /reports/:reportName), the PowerBIClientReact component is fed with correct reportId, embedUrl, accessToken and report is rendered way faster.
      // For more information, see :
      // PowerBI docs : https://learn.microsoft.com/en-us/javascript/api/overview/powerbi/bootstrap-better-performance
      // PowerBI-client-react implementation: https://github.com/microsoft/powerbi-client-react?tab=readme-ov-file#how-to-bootstrap-a-powerbi-report
      {
        path: 'reports/:reportName',
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={4}>
              <RequireSubscription requiresSubscriptionOrTrial>
                <RequireNecessaryData>
                  <Layout />
                </RequireNecessaryData>
              </RequireSubscription>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.connections,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={4}>
              <RequireSubscription>
                <RequireNecessaryData>
                  <Layout>
                    <Connections />
                  </Layout>
                </RequireNecessaryData>
              </RequireSubscription>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.profile,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={5}>
              <RequireSubscription>
                <RequireNecessaryData>
                  <Layout>
                    <Profile />
                  </Layout>
                </RequireNecessaryData>
              </RequireSubscription>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.subscription,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={5}>
              <RequireAccessToPaymentFeatures>
                <RequireSubscription>
                  <RequireProducts>
                    <RequireNecessaryData>
                      <Layout>
                        <Products />
                      </Layout>
                    </RequireNecessaryData>
                  </RequireProducts>
                </RequireSubscription>
              </RequireAccessToPaymentFeatures>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.thanksForPurchase,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={3}>
              <RequireNecessaryData>
                <Layout>
                  <PaymentSuccess />
                </Layout>
              </RequireNecessaryData>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.restrictedAccess,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={3}>
              <RequireSubscription>
                <RequireNecessaryData>
                  <Layout>
                    <RestrictedAccess />
                  </Layout>
                </RequireNecessaryData>
              </RequireSubscription>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.bills,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={4}>
              <RequireAccessToPaymentFeatures>
                <RequireSubscription>
                  <RequireNecessaryData>
                    <Layout>
                      <Bills />
                    </Layout>
                  </RequireNecessaryData>
                </RequireSubscription>
              </RequireAccessToPaymentFeatures>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: '/:idDocumentGroup/:idDocument',
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={3}>
              <RequireNecessaryData>
                <Layout>
                  <IframeDisplay />
                </Layout>
              </RequireNecessaryData>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      },
      {
        path: APP_ROUTES.secrets,
        element: (
          <RequireMaintenanceStatus>
            <RequireAuth numberOfApiCallsToMake={6}>
              <RequireUserNotToBeGuest>
                <RequireSubscription>
                  <RequireNecessaryData>
                    <Layout>
                      <UserSecrets />
                    </Layout>
                  </RequireNecessaryData>
                </RequireSubscription>
              </RequireUserNotToBeGuest>
            </RequireAuth>
          </RequireMaintenanceStatus>
        )
      }
    ]
  }
];

export default routes;
